// @flow
import {
    ADD_DOWNLOAD,
    ADD_DOWNLOAD_PAUSED,
    ADD_ITEM_TO_QUEUE,
    ADD_TO_DOWNLOAD_REQUEST,
    ADD_PLAYLIST_TO_DOWNLOAD_QUEUE,
    CANCEL_DOWNLOAD,
    CLEAN_COMPLETED_DOWNLOADS,
    DOWNLOAD_FILE_FINISH,
    DOWNLOAD_FILE_START,
    IMMEDIATELY_CLEAR_REMAINING_QUEUE,
    INDEX_CONTENT_FAILED,
    INDEX_CONTENT_START,
    INDEX_CONTENT_SUCCESS,
    PAUSE_DOWNLOAD,
    PAUSE_ITEM_DOWNLOAD,
    REFRESH_DOWNLOAD_PROGRESS,
    REMOVE_FROM_DOWNLOAD_REQUEST,
    REMOVE_ITEM_FROM_QUEUE,
    REMOVE_PLAYLIST_FROM_DOWNLOAD_QUEUE,
    REQUEUE_DOWNLOAD,
    RESUME_DOWNLOAD,
    RESET_DOWNLOAD_REQUEST,
    RESUME_ITEM_DOWNLOAD,
    SAVE_DOCUMENT_FAILED,
    SAVE_DOCUMENT_START,
    SAVE_DOCUMENT_SUCCESS,
    MOVE_UP_DOWNLOAD,
    MOVE_DOWN_DOWNLOAD
} from '../actions/downloadManager';

const initialState = {
    downloadQueue: [],
    isDownloading: false,
    isIndexingContent: false,
    isSavingDocument: false,
    isWorkingOnDownloadProcess: false,
    playlistDownloadQueue: [],
    itemQueue: [],
    progress: 0,
    size: "",
    downloaded: "",
    speed: "",
    time: "",
    status: "",
    downloadRequest: []
};

const refreshDownloadProgress = ( downloadQueue, action ) => {
    let newQueue = [ ...downloadQueue ];
    if ( newQueue.length > 0 && newQueue[0].metadata && newQueue[0].metadata.progress !== 100 ) {
        newQueue[0].metadata.progress = action.progress;
        return newQueue;
    } else {
        return downloadQueue;
    }
}

const refreshItemProgress = ( downloadQueue, action ) => {
    // console.info( "refreshItemProgress: ", action.progress );
    let newQueue = [ ...downloadQueue ];
    // if ( newQueue.length > 0 && newQueue[0].progress !== 100 ) {
    if ( newQueue.length > 0 ) {
        newQueue[0].progress = action.progress;
        newQueue[0].status = "Downloading";
        // console.info( "newQueue:\n", newQueue );
    } else {
        // console.info( "Empty queue called:\n", newQueue );
    }
    return newQueue;

}

const cleanCompletedDownloads = ( queue ) => {
    let [ first, ...auxQueue ] = queue;
    const output = auxQueue.filter ( item => item.metadata.uuid !== first.metadata.uuid );
    // console.info( "cleanCompletedDownloads: ", output );
    if ( output.length > 0 ) {
        output[0].progress = 0;
        output[0].status = "Active";
    }
    return output;
}

const startDownload = ( queue, file_id ) => {
    // console.info( "'startDownload' receives 'file_id'", file_id );
    // if(file_id === undefined) {
    //     file_id = queue[0].metadata.properties.file_id;
    // }
    let newQueue = [ ...queue ]
    newQueue.map ( item => {
        if ( file_id === item.metadata.file_id ) {
            item.isDownloading = true;
            item.metadata.status = "Downloading";
            item.metadata.progress = 0;
            item.metadata.wentTrhoughStartDownload = true;
        }
        return null;
    } )

    return newQueue;
}

const pauseDownload = ( queue, index ) => {
    let newQueue = [ ...queue ];
    if ( newQueue[index].metadata ) {
        newQueue[index].metadata.status = "Paused";
    } else {
        // console.info( "pauseDownload no metadata", newQueue[index] )
        newQueue[index].status = "Paused";
    }
    return newQueue;
}

const resumeDownload = ( queue, index ) => {
    let newQueue = [ ...queue ];

    if ( newQueue[index].isDownloading ) {
        if ( newQueue[index].metadata ) {
            newQueue[index].metadata.status = "Downloading";
            newQueue[index].metadata.wentThroughResume = true;
        } else {
            // console.info( "resumeDownload no metadata", newQueue[index] )
            newQueue[index].status = "Downloading";
            newQueue[index].wentThroughResume = true;
        }
    }

    return newQueue;
}

const pauseItemDownload = ( queue, itemID ) => {
    let newQueue = [ ...queue ];

    newQueue.map ( item => {
        if ( itemID === item.id.toString () ) {
            return { ...item, status: "Paused" };
        } else {
            return item
        }
    } );

    return newQueue;
}

const resumeItemDownload = ( queue, itemID ) => {
    let newQueue = [ ...queue ];

    newQueue.map ( item => {
        if ( itemID === item.id.toString () ) {
            return { ...item, status: "Downloading" }
        } else {
            return item
        }
    } );

    return newQueue;
}

const cancelDownload = (queue, index) => {
    let auxQueue = [...queue];
    auxQueue.splice(index, 1);

    return reorderItemQueue(auxQueue);
}

const addItemToQueue = ( itemData, itemQueue ) => {
    let itemEntry = {}
    if ( !itemQueue.map ( item => item.id ).includes ( itemData.id ) ) {
        const newPosition = itemQueue.length - 0;
        itemEntry = {
            id: itemData.id,
            name: itemData.name,
            type: itemData.type,
            progress: 0,
            position: newPosition > 0 ? newPosition : 0,
            status: "Pending",
        }
        return [ ...itemQueue, itemEntry ]
    } else {
        return itemQueue;
    }
}

const removeItemFromQueue = ( itemID, itemQueue ) => {
    let auxQueue;
    if ( Array.isArray ( itemID ) && itemID.length === 0 ) {
        auxQueue = []
    } else {
        auxQueue = itemQueue.filter ( item => item.id !== itemID )
    }

    return reorderItemQueue(auxQueue);
}

const reorderItemQueue = (itemQueue) => {
    let newPosition = 0;

    return itemQueue.map(item => {
        item.position = newPosition;
        newPosition++;

        return item;
    });
}

const addPlaylistToDownloadQueue = ( playlistID, playlistDownloadQueue ) => {
    return [ ...playlistDownloadQueue, playlistID ];
}

const removePlaylistFromDownloadQueue = ( playlistID, playlistDownloadQueue ) => {
    return playlistDownloadQueue.filter ( item => item !== playlistID );
}

const addToDownloadQueue = ( item, downloadQueue ) => {
    const itemFound = downloadQueue.find(element => element.metadata.id === item.metadata.id);
    if (itemFound) {
        return downloadQueue;
    }

    item.isDownloading = false;
    item.metadata.status = "Pending";
    item.metadata.progress = 0;
    item.position = item.metadata?.position ?? 0;

    return sortByPosition([...downloadQueue, item]);
}

const addPausedToDownloadQueue = (item, downloadQueue) => {
    item.isDownloading = false;
    item.metadata.status = 'Paused';
    item.metadata.progress = 0;

    return [...downloadQueue, item];
}

const requeueDownload = ( item, downloadQueue ) => {
    const itemFound = downloadQueue.find(element => element.metadata.id === item.metadata.id);
    if (itemFound) {
        return downloadQueue;
    }

    // console.info( "requeued item: ", item );
    item.whentThroughRequeueDownloadReducer = true;
    const auxQueue = [ ...downloadQueue ];
    item.isDownloading = false;
    item.metadata.status = "Requeued";
    item.metadata.progress = 0;
    item.position = item.metadata?.position ?? 0;

    return sortByPosition([...auxQueue, item]);
}

const markFirstAsProcessing = (downloadQueue) => {
    const auxQueue = [...downloadQueue];
    if (auxQueue.length > 0 && auxQueue[0]?.metadata?.status) {
        auxQueue[0].metadata.status = "Processing";
    }

    if (auxQueue.length > 0 && auxQueue[0]?.status) {
        auxQueue[0].status = "Processing";
    }

    return auxQueue;
}

const addToDownloadRequest = ( itemID, downloadRequest ) => {

    const auxQueue = [ ...downloadRequest ]
    if ( auxQueue.includes ( itemID ) ) {
        return auxQueue
    } else {
        return [ ...auxQueue, itemID ]
    }

}

const removeFromDownloadRequest = ( itemID, downloadRequest ) => {
    return downloadRequest.filter ( item => item !== itemID );
}

const moveUpDownload = (queue, moveIndex) => {
    let elements = [...queue];
    if (0 === elements.length) {
        return elements;
    }

    const currentPosition = elements[moveIndex].position;
    const newPosition = currentPosition - 1;
    if (newPosition < 1) {
        return elements;
    }

    return assignPositionAndSort(
      elements,
      moveIndex,
      newPosition,
      currentPosition
    );
}

const moveDownDownload = (queue, moveIndex) => {
    let elements = [...queue];
    if (0 === elements.length) {
        return elements;
    }

    let currentPosition = elements[moveIndex].position;
    if (0 === currentPosition) {
        return elements;
    }

    const countElements = elements.length;
    let newPosition = currentPosition + 1;
    if (newPosition >= countElements) {
        return elements;
    }

    return assignPositionAndSort(
      elements,
      moveIndex,
      newPosition,
      currentPosition
    );
}

const assignPositionAndSort = (elements, moveIndex, newPosition, currentPosition) => {
    elements[moveIndex].position = newPosition;

    const newElements = elements.map((item, index) => {
        if (newPosition === item.position && index !== moveIndex) {
            return {...item, position: currentPosition}
        }

        return item
    });

    return sortByPosition(newElements);
}

const sortByPosition = (elements) => {
    elements.sort((firstItem, secondItem) => {
        return firstItem.position > secondItem.position ? 1 : -1;
    });

    return elements;
}

//Reducer that manages the downloads in the application
export default function downloadManager ( state = initialState, action ) {
    const { downloadQueue, playlistDownloadQueue, itemQueue, downloadRequest } = state;
    switch ( action.type ) {
        case ADD_DOWNLOAD:
            return {
                ...state,
                downloadQueue: addToDownloadQueue ( action.document, downloadQueue ),
                status: "Pending"
            };
        case ADD_DOWNLOAD_PAUSED:
            return {
                ...state,
                downloadQueue: addPausedToDownloadQueue(action.document, downloadQueue),
                status: 'Paused'
            };
        case REQUEUE_DOWNLOAD:
            return {
                ...state,
                downloadQueue: requeueDownload ( action.document, downloadQueue ),
                status: "Pending"
            };

        case PAUSE_DOWNLOAD:
            return {
                ...state,
                downloadQueue: pauseDownload ( downloadQueue, action.index ),
                status: "Paused"
            };

        case RESUME_DOWNLOAD:
            return {
                ...state,
                downloadQueue: resumeDownload ( downloadQueue, action.index ),
                status: "Downloading"
            };

        case PAUSE_ITEM_DOWNLOAD:
            return {
                ...state,
                downloadQueue: pauseItemDownload ( itemQueue, action.itemID ),
                status: "Paused"
            };

        case RESUME_ITEM_DOWNLOAD:
            return {
                ...state,
                downloadQueue: resumeItemDownload ( itemQueue, action.itemID ),
                status: "Downloading"
            };

        case CANCEL_DOWNLOAD:
            return {
                ...state,
                downloadQueue: cancelDownload ( downloadQueue, action.index ),
                status: ""
            };


        case DOWNLOAD_FILE_START:
            if ( !action.hasOwnProperty ( 'file_id' ) ) {
                action.file_id = downloadQueue[0].metadata.properties.file_id;
                // console.table( downloadQueue[0] );
                // console.info( "DOWNLOAD_FILE_START without file_id: ", action )
            } else {
                // console.info( "DOWNLOAD_FILE_START with file_id: ", action )
            }
            return {
                ...state,
                downloadQueue: startDownload ( downloadQueue, action.file_id ),
                isDownloading: true,
                isWorkingOnDownloadProcess: true,
                status: "Downloading"
            };
        case DOWNLOAD_FILE_FINISH:
            return {
                ...state,
                downloadQueue: markFirstAsProcessing(downloadQueue),
                isDownloading: false,
                isWorkingOnDownloadProcess: false,
                status: "Processing"
            };
        case SAVE_DOCUMENT_START:
            return { ...state, isSavingDocument: true };
        case SAVE_DOCUMENT_SUCCESS:
            return { ...state, isSavingDocument: false };
        case SAVE_DOCUMENT_FAILED:
            return { ...state, isSavingDocument: false };
        case REFRESH_DOWNLOAD_PROGRESS:
            return {
                ...state,
                isDownloading: true,
                downloadQueue: refreshDownloadProgress ( downloadQueue, action ),
                itemQueue: refreshItemProgress ( itemQueue, action ),
                progress: action.progress,
                size: action.size,
                downloaded: action.downloaded,
                speed: action.speed,
                time: action.time
            };
        case INDEX_CONTENT_START:
            return { ...state, isIndexingContent: true };
        case INDEX_CONTENT_SUCCESS:
            return { ...state, isIndexingContent: false };
        case INDEX_CONTENT_FAILED:
            return { ...state, isIndexingContent: false };
        case CLEAN_COMPLETED_DOWNLOADS:
            // console.info( "cleanCompleteDownloads method is invoked with downloadQueue" )
            const dq = cleanCompletedDownloads ( downloadQueue );
            return {
                ...state,
                downloadQueue: dq,
                isWorkingOnDownloadProcess: dq.length > 0
            };
        case ADD_ITEM_TO_QUEUE:
            return {
                ...state,
                itemQueue: addItemToQueue ( action.item, itemQueue ),
                status: "Downloading"
            }

        case IMMEDIATELY_CLEAR_REMAINING_QUEUE:
            return {
                ...state,
                itemQueue: [],
                playlistDownloadQueue: [],
                status: "",
                isDownloading: false,
                isWorkingOnDownloadProcess: false,
            }

        case REMOVE_ITEM_FROM_QUEUE:
            return {
                ...state,
                itemQueue: removeItemFromQueue ( action.itemID, itemQueue )
            }

        case ADD_PLAYLIST_TO_DOWNLOAD_QUEUE:
            return {
                ...state,
                playlistDownloadQueue: addPlaylistToDownloadQueue ( action.playlistID, playlistDownloadQueue ),
                isDownloading: true,
                isWorkingOnDownloadProcess: true
            };
        case REMOVE_PLAYLIST_FROM_DOWNLOAD_QUEUE:
            return {
                ...state,
                playlistDownloadQueue: removePlaylistFromDownloadQueue ( action.playlistID, playlistDownloadQueue )
            }
        case ADD_TO_DOWNLOAD_REQUEST:
            return {
                ...state,
                downloadRequest: addToDownloadRequest ( action.request, downloadRequest )
            }
        case REMOVE_FROM_DOWNLOAD_REQUEST:
            return {
                ...state,
                downloadRequest: removeFromDownloadRequest ( action.request, downloadRequest )
            }
        case RESET_DOWNLOAD_REQUEST:
            return {
                ...state,
                downloadRequest: []
            }
        case MOVE_UP_DOWNLOAD:
            return {
                ...state,
                itemQueue: moveUpDownload(itemQueue, action.index),
                downloadQueue: moveUpDownload(downloadQueue, action.index),
            }
        case MOVE_DOWN_DOWNLOAD:
            return {
                ...state,
                itemQueue: moveDownDownload(itemQueue, action.index),
                downloadQueue: moveDownDownload(downloadQueue, action.index),
            }
        default:
            return state;
    }
}